import { z } from 'zod';
const promoteShiftsParamsSchema = z.object({
    missionId: z.string().uuid(),
});
export const promoteShiftsFunctionDef = {
    name: 'promoteShifts',
    requestSchema: promoteShiftsParamsSchema,
    responseSchema: z.void(),
};
